/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

export enum SupportMenuLinks {
	ADMIN_USER_RESOURCES = 'https://knowledge-base.touchplan.io/admin-user-resources/',
	BASIC_USER_RESOURCES = 'https://knowledge-base.touchplan.io/basic-user-resources/',
	HELP_CENTER = 'https://intercom.help/touchplanio/en/',
}
